// Interface

import util from '@/utils/classToObject'
import { IAdministrationState } from './state'

export class AdministrationGetter {
    public fluxStatus(state: IAdministrationState) {
        return state.fluxStatus
    }
    public flux(state: IAdministrationState) {
        return state.flux
    }
    public fluxList(state:IAdministrationState){
        return state.fluxList.item.map( id => state.flux[id] )
    }
    
    public partenaireStatus(state: IAdministrationState) {
        return state.partenaireStatus
    }
    public partenaire(state: IAdministrationState) {
        return state.partenaire
    }
    public partenaireList(state:IAdministrationState){
        return state.partenaireList.item.map( id => state.partenaire[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    }
    
    public dataSourcesStatus(state: IAdministrationState) {
        return state.dataSourcesStatus
    }
    public dataSources(state: IAdministrationState) {
        return state.dataSources
    }
    public dataSourcesList(state:IAdministrationState){
        return state.dataSourcesList.item.map( id => state.dataSources[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    }

    public feedDownloadsStatus(state: IAdministrationState) {
        return state.feedDownloadsStatus
    }
    
    public feedDownloads(state: IAdministrationState) {
        return state.feedDownloads
    }
    
    public feedDownloadsList(state:IAdministrationState){
        return state.feedDownloadsList.item.map( id => state.feedDownloads[id] )
    }

    //////////////////////////////////////////////////////////////////
    // PERSONNE
    /////////////////////////////////////////////////////////////////
    public personneStatus(state: IAdministrationState) {
        return state.personneStatus
    }
    public personneDic(state: IAdministrationState) {
        return state.personneDic
    }
    public personneList(state:IAdministrationState){
        return state.personneList.item.map( id => state.personneDic[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    } 


    //////////////////////////////////////////////////////////////////
    // PROFIL_EXCLUSION
    /////////////////////////////////////////////////////////////////
    public profilExclusionStatus(state: IAdministrationState) {
        return state.profilExclusionStatus
    }
    public profilExclusion(state: IAdministrationState) {
        return state.profilExclusion
    }
    public profilExclusionList(state:IAdministrationState){
        return state.profilExclusionList.item.map( id => state.profilExclusion[id] )
    }

    
    //////////////////////////////////////////////////////////////////
    // GROUP_CARAC
    /////////////////////////////////////////////////////////////////
    public groupCaracStatus(state: IAdministrationState) {
        return state.groupCaracStatus
    }
    public groupCarac(state: IAdministrationState) {
        return state.groupCarac
    }
    public groupCaracList(state:IAdministrationState){
        return state.groupCaracList.item.map( id => state.groupCarac[id] )
    }
    public carac(state: IAdministrationState) {
        return state.carac
    }
    public caracList(state:IAdministrationState){
        return state.caracList.item.map( id => state.carac[id] )
    }    
}

export default util.classToObject(AdministrationGetter)